// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_NHw","cls2":"AnalyticsV2NavBar-cls2_cDK AnalyticsV2NavBar-cls1_NHw"};